import { useDrop } from 'react-dnd';
import { useState } from 'react';
import { updateSingleProject } from '../../hooks/db';
import ProjectBlobNarrow from './ProjectBlobNarrow';
import { Link } from "react-router-dom";
import { ArrowUpDown, CaseSensitive, Contact } from 'lucide-react';

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const parseCurrency = (val) => Number(String(val).replace(/[^0-9.-]+/g, "")) || 0;

const ProjectLink = ({ project }) => (
    <Link to="/project" state={{ project_id: project.project_id }} key={project.project_id}>
        <ProjectBlobNarrow project={project} />
    </Link>
);

const SortedList = ({ projects, sort }) => {
    if (sort === "alpha") {
        const sorted = [...projects].sort((a, b) => a.title.localeCompare(b.title));
        return (
            <div className="flex flex-col gap-1">
                {sorted.map(p => <ProjectLink key={p.project_id} project={p} />)}
            </div>
        );
    }
    if (sort === "client") {
        const groups = {};
        [...projects].sort((a, b) => a.client.localeCompare(b.client)).forEach(p => {
            if (!groups[p.client]) groups[p.client] = [];
            groups[p.client].push(p);
        });
        return (
            <div className="flex flex-col gap-3">
                {Object.entries(groups).map(([client, clientProjects]) => (
                    <div key={client}>
                        <div className="text-[9px] uppercase tracking-[0.18em] font-semibold text-[#555] mb-1.5 pl-1">{client}</div>
                        <div className="flex flex-col gap-1">
                            {clientProjects.map(p => <ProjectLink key={p.project_id} project={p} />)}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
    // group by month descending
    const sorted = [...projects].sort((a, b) => new Date(b.due_date) - new Date(a.due_date));
    const groups = {};
    sorted.forEach(p => {
        const d = new Date(p.due_date);
        const key = `${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(p);
    });
    return (
        <div className="flex flex-col gap-3">
            {Object.entries(groups).map(([month, monthProjects]) => (
                <div key={month}>
                    <div className="text-[9px] uppercase tracking-[0.18em] font-semibold text-[#555] mb-1.5 pl-1">{month}</div>
                    <div className="flex flex-col gap-1">
                        {monthProjects.map(p => <ProjectLink key={p.project_id} project={p} />)}
                    </div>
                </div>
            ))}
        </div>
    );
};

const updateProject = async (updatedProject) => {

    try {
        await updateSingleProject(updatedProject.project_id, updatedProject);
    } catch (err) {
        console.error("Error updating project: ", err);
        return;
    } finally {
        console.log("Updating project...");
    }
}

const ProjectBasket = (props) => {

    const status = props.category.status;
    const category = props.category;
    const setProjects = props.setProjects;
    const [completedSort, setCompletedSort] = useState("date");

    const filteredProjects = props.projects
        .filter(c => c.status == status)
        .map(c => (
            <Link
                to="/project"
                state={{ project_id: c.project_id }}
                key={c.project_id}
            >
                <ProjectBlobNarrow key={c.project_id} project={c} />
            </Link>
        ))
    //console.log('Filtered Projects:', props.projects);
    // const basket = props.projects.filter(
    //     project => project.status === status
    // );


    const [{ isOver }, dropRef] = useDrop({
        accept: 'project',
        drop: (item) => {
        console.log('Dropped item:', item);
            const updatedProject = item.project;
            updatedProject.status = category.status;
            updateProject(updatedProject); // 👈 add this
        setProjects(prev =>
            prev.map(project =>
            project.project_id === item.project_id
                ? { ...project, status }
                : project
            )
            );
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })
if (category.status != "Complete") {
return (
        <div
            key={category.status}
            ref={dropRef}
           className={`min-w-[300px] max-w-[475px] min-h-[100px] gradientBG
                pt-2 pb-3 px-3 basket
                outline outline-dashed outline-2
                transition-[outline-color] duration-300 ease-in-out
                ${isOver ? "outline-yellow-500/50" : "outline-transparent"}
            `}
        >
            <h5 className="uppercase text-xs tracking-wider">{category.label}</h5>
            <div className="hBar mt-[2px] mb-[10px]" style={{ backgroundColor: category.color }}></div>
            <div className="flex flex-col gap-1"></div>

            {filteredProjects}
            {/* </div> */}
        </div>
)
} else {

    const rawComplete = props.projects.filter(c => c.status === "Complete");
    const paidRaw   = rawComplete.filter(p => parseCurrency(p.paid) >= parseCurrency(p.fee));
    const unpaidRaw = rawComplete.filter(p => parseCurrency(p.paid) <  parseCurrency(p.fee));

    const SortControls = () => (
        <div className="flex items-center gap-1 mb-2">
            <span className="text-[9px] uppercase tracking-wider text-[#444] mr-1">Sort</span>
            <button
                onClick={() => setCompletedSort("date")}
                className={`flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-md transition-all duration-150 ${completedSort === "date" ? "bg-[rgba(255,238,0,0.1)] text-[#ffee00] border border-[rgba(255,238,0,0.25)]" : "text-[#555] hover:text-[#aaa]"}`}
            >
                <ArrowUpDown size={10}/> Date
            </button>
            <button
                onClick={() => setCompletedSort("alpha")}
                className={`flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-md transition-all duration-150 ${completedSort === "alpha" ? "bg-[rgba(255,238,0,0.1)] text-[#ffee00] border border-[rgba(255,238,0,0.25)]" : "text-[#555] hover:text-[#aaa]"}`}
            >
                <CaseSensitive size={10}/> A–Z
            </button>
            <button
                onClick={() => setCompletedSort("client")}
                className={`flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-md transition-all duration-150 ${completedSort === "client" ? "bg-[rgba(255,238,0,0.1)] text-[#ffee00] border border-[rgba(255,238,0,0.25)]" : "text-[#555] hover:text-[#aaa]"}`}
            >
                <Contact size={10}/> Client
            </button>
        </div>
    );

    return (
        <div
            key={category.status}
            ref={dropRef}
            className={`min-h-[100px] gradientBG
                flex flex-col
                pt-2 pb-3 px-3 basket
                outline outline-dashed outline-2
                transition-[outline-color] duration-300 ease-in-out
                ${isOver ? "outline-yellow-500/50" : "outline-transparent"}
            `}
        >
            <h5 className="uppercase text-xs tracking-wider">{category.label}</h5>
            <div className="hBar mt-[2px] mb-[10px]" style={{ backgroundColor: category.color }}></div>
            <div className="flex flex-row m-auto gap-8">
                <div className="min-w-[300px] max-w-[475px]">
                    <h5 className="uppercase text-xs tracking-wider">Unpaid</h5>
                    <div className="hBar mt-[2px] mb-[10px] bg-[#cccccc]"></div>
                    <SortedList projects={unpaidRaw} sort={completedSort} />
                </div>
                <div className="min-w-[300px] max-w-[475px]">
                    <div className="flex items-center justify-between">
                        <h5 className="uppercase text-xs tracking-wider">Completed</h5>
                        <SortControls />
                    </div>
                    <div className="hBar mt-[2px] mb-[10px] bg-[#cccccc]"></div>
                    <div className="overflow-y-auto max-h-[400px] pr-1">
                        <SortedList projects={paidRaw} sort={completedSort} />
                    </div>
                </div>
            </div>
        </div>
    );
}
}

export default ProjectBasket;